module.exports = __webpack_public_path__ + "static/img/user_square.82237887.png";